import { useQuery } from '@tanstack/react-query';
import { getUnpublishedInspectionsCount } from '../services/AIInspectionManagerService';
export default function useUnpublishedInspectionsCount(days, options = { enabled: true }) {
    return useQuery(['unpublishedInspectionsCount', days], () => getUnpublishedInspectionsCount(days), {
        staleTime: 30 * 1000,
        cacheTime: 5 * 60 * 1000,
        enabled: days > 0 && options.enabled
    });
}
